import { render, staticRenderFns } from "./LangForm.vue?vue&type=template&id=3e0c333c&scoped=true"
import script from "./LangForm.vue?vue&type=script&lang=js"
export * from "./LangForm.vue?vue&type=script&lang=js"
import style0 from "./LangForm.vue?vue&type=style&index=0&id=3e0c333c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0c333c",
  null
  
)

export default component.exports